module.exports = __webpack_public_path__ + "static/media/MD-OH Sample Info - Sheet1.302ba039.tsv";